import { render } from "./page-calendar.vue?vue&type=template&id=1addbc54"
import script from "./page-calendar.vue?vue&type=script&lang=js"
export * from "./page-calendar.vue?vue&type=script&lang=js"

import "./page-calendar.vue?vue&type=style&index=0&id=1addbc54&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__